import {Injectable, signal} from '@angular/core';
import {SelectData} from "../../../../../types/records-table.types";

@Injectable({
  providedIn: 'root'
})
export class DynamicSelectStateService {
  private _dynamicState = signal<Record<string, Array<SelectData>>>({});
  public dynamicState = this._dynamicState.asReadonly();

  public setDynamicState(key: string, value: Array<SelectData>): void {
    this._dynamicState.update(currentState => ({
      ...currentState,
      [key]: value
    }));
  }

  public resetDynamicState(): void {
    this._dynamicState.set({});
  }
}
